export const comments_5187253 = {"data":{"data":[],"links":{}}}